import { SortByItem } from "instantsearch.js/es/connectors/sort-by/connectSortBy";
import { useState } from "react";
import Portal from "../Portal/Portal";
import { useSortBy } from "react-instantsearch";
import { algoliaConfig } from "../../data/config";

interface FilterModalProps {
    isOpen: boolean;
    handleClose: () => void
    handleRefinement: (value: string) => void
    sortOptions: SortByItem[]
}

export default function SortMobileModal({ isOpen, handleClose, sortOptions, handleRefinement}: FilterModalProps) {

    const { 
        initialIndex, 
        currentRefinement,
        options,
        refine,
        canRefine
    } = useSortBy({
        items: [
            { label: 'Relevance', value: algoliaConfig.MATERIAL_INDEX},
            { label: 'Alphabetical', value: `${algoliaConfig.MATERIAL_INDEX}_alphabetical`},
            { label: 'New Release', value: `${algoliaConfig.MATERIAL_INDEX}_new-release`}
        ]
    });
    
    const [selectedSort, setSelectedSort] = useState("Relevance");

    const getWindowValue = (label: string) => {
        if(label === "Relevance" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.relevance) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.relevance
        }

        if(label === "Alphabetical" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.alphabetical) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.alphabetical
        }

        if(label === "New Release" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.new_release) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.new_release;
        }

        return label;
    }

    return (
        <Portal wrapperId="fl-sort-modal">
            <div className={"fl-container__mb-modal"} style={!isOpen ? {display: "none"} : {}}>
                <div className={"finish-filters-mobile-modal__container"}>
                    <div className={"finish-filters-mobile-modal__header"}>
                        <h1>{window.steelcase_i18n['steelcase-finish-library'].sort.sort_by || "Sort by"}</h1>
                        <button className={"finish-filters-mobile-modal__close"} onClick={handleClose}>X</button>
                    </div>

                    <section className={`finish-filters-modal__filter-section`}>
                        {
                            sortOptions.map((option, idx) => {
                                return (
                                    <div 
                                        onClick={() => {
                                            if (option.value) {
                                                handleRefinement(option.value);
                                            }
                                        }} 
                                        key={`${idx}-mobile`} 
                                        className={"finish-filters-mobile-modal__sort-option"}
                                    >
                                        <label className={"finish-sort__label"}>
                                            <input 
                                                key={`${option.label}-mobile`}
                                                className={"finish_sort__control"} 
                                                checked={currentRefinement === option.value} 
                                                type="radio" 
                                                id={option.label} 
                                                name="sort_by" 
                                                onClick={() => {
                                                    if (option.value) {
                                                        refine(option.value);
                                                        setSelectedSort(option.label);
                                                    }
                                                }}
                                            />
                                            <span>{getWindowValue(option.label)}</span>
                                        </label>
                                    </div>
                                )
                            })
                        }
                    </section>
                </div>
            </div>
        </Portal>
    )
}